export const RESEND_ACTIVATION_VIEW = {
  FORM: 'form',
  SENT: 'sent',
} as const;

export type ResendActivationView = (typeof RESEND_ACTIVATION_VIEW)[keyof typeof RESEND_ACTIVATION_VIEW];

export const RESEND_ACTIVATION_FORM_SUBTITLE
  = 'Add the email linked to the account you want a new activation email for.';
export const RESEND_ACTIVATION_EMAIL_LABEL = 'Username';
export const RESEND_ACTIVATION_EMAIL_PLACEHOLDER = 'johndoe@scalar.io';
export const RESEND_ACTIVATION_LINK_LABEL = 'Resend activation email';
export const RESEND_ACTIVATION_SUBMIT_LABEL = 'Resend activation email';
export const RESEND_ACTIVATION_FORM_SUBMIT_LABEL = 'Email me an activation link';
export const RESEND_ACTIVATION_EMAIL_SENT_TITLE = 'Check your email';
export const RESEND_ACTIVATION_RESEND_ACTION_LABEL = 'Resend activation message';
export const RESEND_ACTIVATION_ERROR = 'Unable to resend the activation email right now. Please try again later.';
export const RESEND_ACTIVATION_RESEND_MISSING_EMAIL_ERROR
  = 'We could not determine which email to resend. Return and submit the form again.';
export const RESEND_ACTIVATION_EMAIL_REQUIRED_ERROR = 'Enter your username.';
export const RESEND_ACTIVATION_EMAIL_FORMAT_ERROR = 'Enter a valid username.';
export const RESEND_ACTIVATION_EMAIL_SENT_DESCRIPTION = 'An activation message was sent to your email.';
